// extracted by mini-css-extract-plugin
export default {"overlayImagesContainer":"TJ-z","loadingMedia":"UJ-z","reviewsImagesAndVideos":"VJ-z","limitHeight":"WJ-z"};